import { defineComponent, computed } from "vue";
import isNull from "./component-library285.mjs";
import isUndefined from "./component-library286.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "dropdown-item-content",
  props: {
    label: { default: "" },
    count: { default: void 0 },
    selected: { type: Boolean, default: false },
    breakText: { type: Boolean }
  },
  setup(__props, { expose }) {
    const props = __props;
    const hasCount = computed(() => !isNull(props.count) && !isUndefined(props.count));
    expose({ hasCount });
    return { __sfc: true, props, hasCount };
  }
});
export {
  _sfc_main as default
};
